import React from "react";
import { Calendar } from "primereact/calendar";

const minDate = new Date(1946, 5, 25); // 25 giugno 1946
const maxDate = new Date(1948, 0, 31); // 31 gennaio 1948

export default function FiltroData({ value, onChange }) {
    const { start, end } = value;

    return (
        <div className="grid">
            <div className="col-12 md:col-6">
                <label htmlFor="start" className="font-semibold">Data inizio</label>
                <Calendar id="start" value={start} onChange={(e) => onChange({ ...value, start: e.value })} dateFormat="dd/mm/yy"
                    minDate={minDate} maxDate={end || maxDate} className="w-full" viewDate={new Date(1946, 5, 25)}
                />
            </div>
            <div className="col-12 md:col-6">
                <label htmlFor="end" className="font-semibold">Data fine</label>
                <Calendar id="end" value={end} onChange={(e) => onChange({ ...value, end: e.value })} dateFormat="dd/mm/yy"
                    minDate={start || minDate} maxDate={maxDate} viewDate={new Date(1948, 0, 31)} className="w-full"
                />
            </div>
        </div>
    );
}
